// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel{height:var(--carousel-height)}.carousel-inner,.carousel-item{height:100%}.carousel-item img{height:100%;-o-object-fit:contain;object-fit:contain}@media(min-width:992px)and (max-width:99999px){.carousel-item img{-o-object-fit:cover;object-fit:cover}}.carousel-indicators li{width:12px;height:12px;margin-right:8px;background:rgba(0,0,0,.13333);border-radius:24px}.carousel-indicators li.active{background:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
